import CaptchaException from "@rmp/core/exceptions/captchaException";
import OfflineException from "@rmp/core/exceptions/offlineException";
import ServerUnavailableException from "@rmp/core/exceptions/serverUnavailableException";
import RequestCancelledException from "@rmp/core/exceptions/requestCancelledException";
import alertService, { AlertKeys } from "@rmp/core/stores/alerts/services/alertService";
import HttpNotFoundException from "@rmp/core/exceptions/httpNotFoundException";
import AccessForbiddenException from "@rmp/core/exceptions/accessForbiddenException";
import { normalizeError } from "@rmp/core/api/errors/classifyError";
import ProblemDetailsException from "@rmp/core/exceptions/problemDetailsException";

export default class AlertHelper {
	static handleGeneralRequestErrors(error: unknown) {
		const classifiedError = normalizeError(error);
		
		console.error(classifiedError);
		
		if(classifiedError instanceof RequestCancelledException) {
			return;
		} else if(classifiedError instanceof CaptchaException) {
			alertService.addError(AlertKeys.CAPTCHA_ERROR);
		} else if(classifiedError instanceof OfflineException) {
			alertService.addError(AlertKeys.OFFLINE_REQUEST_ERROR);
		} else if(classifiedError instanceof ServerUnavailableException) {
			alertService.addError(AlertKeys.SERVER_UNAVAILABLE_ERROR);
		} else if(classifiedError instanceof HttpNotFoundException) {
			alertService.addError(AlertKeys.PAGE_NOT_FOUND);
		} else if(classifiedError instanceof AccessForbiddenException) {
			alertService.addError(AlertKeys.ACCESS_FORBIDDEN);
		} else if(classifiedError instanceof ProblemDetailsException && classifiedError.displayMessage) {
			alertService.addCustomError(classifiedError.displayMessage);
		} else {
			alertService.addError(AlertKeys.REQUEST_UNKNOWN_ERROR);
		}
	}
}
